import slugify from "slugify";
import axios from "axios";
import { toastr } from "react-redux-toastr";

import config from "../config";
import { getAuthToken } from "../utils/sessionStorage";

export function uploadFile(file, video) {
  return new Promise((resolve, reject) => {
    toastr.info("Fazendo upload de arquivo");
    axios({
      method: "post",
      headers: { "X-User-Token": getAuthToken() },
      url: `${config.url}/upload/cdn`,
      data: {
        base_key: video.id
      }
    }).then(res => {
      let data = res.data;
      // Tratamento de nome para upload pro s3
      let parts = file.name.split(".");
      let ext = parts[parts.length - 1];
      let regexp = new RegExp("\\." + ext);
      let basename = file.name.replace(regexp, "");

      let metadata = {};
      metadata.upload_url = "//" + data.bucket + ".s3.amazonaws.com/";
      metadata.key = data.base_key + slugify(basename, "_") + "." + ext;

      metadata.public_url = "//" + video.cdn_subdomain + ".overmediacast.com/" + metadata.key;

      var formData = new FormData();
      formData.append("AWSAccessKeyId", data.accessKeyId);
      formData.append("Policy", data.policy);
      formData.append("Signature", data.signature);
      formData.append("key", metadata.key);
      formData.append("acl", "public-read");
      formData.append("Content-Type", file.type);
      formData.append("success_action_status", "201");
      formData.append("file", file);
      axios({
        method: "post",
        url: metadata.upload_url,
        headers: { "content-type": "multipart/form-data" },
        data: formData
      })
        .then(res => {
          toastr.success("Upload feito com sucesso");
          resolve(metadata.public_url);
        })
        .catch(err => {
          toastr.error("Erro ao fazer upload");
          reject(err);
        });
    });
  });
}



// WEBPACK FOOTER //
// ./src/utils/uploadFile.js